<div class="tvd-box">
    <div>
        <div class="dollar-value">
            + ${{totalOpportunityTVD.toString() | abbreviateNumber}}
        </div>
        <div class="heading-group">
            <span class="title">
                Total Value Delivered Opportunity
            </span>
            <span class="percent">
                <img src="assets/upArrow.svg" alt="up arrow">{{tvdDeltaPercent}} %
            </span>
        </div>

        <div class="bottom-section">
            <div class="text-group">
                <div class="spacer"></div>
                <div class="subtext current">Current</div>
                <div class="subtext">Opportunities</div>
            </div>

            <!-- Carousel Section -->
            <div class="metrics-carousel">
                <!-- ngx-slick-carousel requires jQuery version 3.7.1, however this has known vulnerabilities.
                  JQuery version 4.0.0 has no known vulnerabilities, but ng-slick-carousel is currently incompatible with it.
                  Once ng-slick-carousel is compatible with jQuery 4.0.0, it can be used safely. -->
                <!-- <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                    <div class="carousel-group slide" ngxSlickItem *ngFor="let item of carouselItems">
                        <div class="icon">
                            <img src="{{item.imgUrl}}" alt="metrics-icon" />
                            <div class="metric-name">{{item.metricName}}</div>
                        </div>
                        <div class="current-value">${{item.currentTVDValue | abbreviateNumber}}</div>
                        <div class="opportunity-value">${{item.opportunityTVDValue | abbreviateNumber}}</div>
                    </div>
                </ngx-slick-carousel> -->
                
                <button type="button" class="carousel-arrow prev"
                    (click)="prevSlide()" aria-label="Previous metrics">
                    <img src="assets/shared-icons/neptune-icon-blue-chevron-right.svg" alt="" />
                </button>

                <div class="carousel-viewport">
                    <div class="carousel-group" *ngFor="let item of visibleItems; trackBy: trackByMetricName">
                        <div class="icon">
                            <img src="{{item.imgUrl}}" alt="metrics-icon" />
                            <div class="metric-name">{{item.metricName}}</div>
                        </div>
                        <div class="current-value">${{item.currentTVDValue | abbreviateNumber}}</div>
                        <div class="opportunity-value">${{item.opportunityTVDValue | abbreviateNumber}}</div>
                    </div>
                </div>

                <button type="button" class="carousel-arrow next"
                    (click)="nextSlide()" aria-label="Next metrics">
                    <img src="assets/shared-icons/neptune-icon-blue-chevron-right.svg" alt="" />
                </button>
            </div>
        </div>
    </div>
</div>